export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M21 21v-2H3v2zm0-4v-2H3v2zm0-4v-2H3v2zm0-4V7H3v2zM3 5h18V3H3z\" clip-rule=\"evenodd\"/>"
};